import axios from 'axios'
import queryString from 'query-string'
import {
  BudgetRequestDetailResponse,
  BudgetRequestMutationResponse,
  BudgetRequestsListParams,
  BudgetRequestsListResponse,
  PatchBudgetRequestBody,
  PostBudgetRequestBody,
} from 'src/queries/budgetRequests/budgetRequests.models'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export const getBudgetRequestsList = async (
  params: BudgetRequestsListParams,
): Promise<BudgetRequestsListResponse> =>
  getResponseData(
    axios.get<BudgetRequestsListResponse>(
      `/budgetrequests?${queryString.stringify(params)}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )

export const getBudgetRequestDetail = async (
  budgetRequestId: string,
): Promise<BudgetRequestDetailResponse> =>
  getResponseData(
    axios.get<BudgetRequestDetailResponse>(
      `/budgetrequests/${budgetRequestId}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )

export const postBudgetRequest = async (
  body: PostBudgetRequestBody,
): Promise<BudgetRequestMutationResponse> =>
  getResponseData(
    axios.post<BudgetRequestMutationResponse>(
      '/budgetrequests',
      body,
      getRequestConfig(RequestConfig.Default),
    ),
  )

export const patchBudgetRequest = async (
  budgetRequestId: string,
  body: PatchBudgetRequestBody,
): Promise<BudgetRequestMutationResponse> =>
  getResponseData(
    axios.patch<BudgetRequestMutationResponse>(
      `/budgetrequests/${budgetRequestId}`,
      body,
      getRequestConfig(RequestConfig.Default),
    ),
  )
